import moment from 'moment'
import { resolveActionFormValues } from './resolveAnnouncementActions'

const LOCAL_DATE_TIME = 'YYYY-MM-DDTHH:mm'

const emptyAnnouncement = {
    name: '',
    notes: '',
    title: '',
    caption: '',
    moreInfoText: '',
    bodyText: '',
    conversionButtonText: '',
    conversionMessage: '',
    emailTemplate: '',
    frequency: 'oncePerUser',
    startAt: '',
    endAt: '',
    image: null,
    imageFile: null,
    isContentLocked: false,
    isPublished: false,
}

function toLocalDateTime(value) {
    return value == null || value === ''
        ? ''
        : moment(value).format(LOCAL_DATE_TIME)
}

export function resolveAnnouncementFormValues(announcement) {
    const stored = announcement ?? {}

    return {
        ...emptyAnnouncement,
        name: stored.name ?? '',
        notes: stored.notes ?? '',
        title: stored.title ?? '',
        caption: stored.caption ?? '',
        moreInfoText: stored.moreInfoText ?? '',
        bodyText: stored.bodyText ?? '',
        conversionButtonText: stored.conversionButtonText ?? '',
        conversionMessage: stored.conversionMessage ?? '',
        emailTemplate: stored.emailTemplate ?? '',
        ...resolveActionFormValues(stored.actions),
        frequency: stored.frequency ?? 'oncePerUser',
        startAt: toLocalDateTime(stored.startAt),
        endAt: toLocalDateTime(stored.endAt),
        image: stored.image ?? null,
        imageFile: null,
        isContentLocked: Boolean(stored.isContentLocked),
        isPublished: Boolean(stored.isPublished),
    }
}
